<template>
  <div class="pdf-container">
    <div v-if="isPhone">
      <p>
        Click <a :href="PDFuri"><b>HERE</b></a> to download and view your full report
      </p>
    </div>
    <object v-else :data="PDFuri" type="application/pdf" style="height: 100%; width: 100%">
      <p>
        Click <a :href="PDFuri"><b>HERE</b></a> to download and view your full report
      </p>
    </object>

    <loader :is-visible="isLoading" />
  </div>
</template>

<style scoped>
.pdf-container {
  height: 83vh;
  width: 100%;
}
</style>
<script>
import { mapGetters } from "vuex"
import Swal from "sweetalert2"
import loader from "@/components/GlobeChek/loader.vue"

export default {
  name: "NewComponent",
  components: {
    loader,
  },
  data() {
    return {
      PDFpath: process.env.VUE_APP_SCREENING_REPORTS,
      PDFuri: "",
      isLoading: false
    }
  },
  computed: {
    ...mapGetters(["isPhone"])
  },
  mounted: function () {
    this.viewPDF()
    this.isLoading = true;
    setTimeout(() => {
      this.isLoading = false;
    }, 8000)
  },
  methods: {
    async viewPDF() {
      try {
        const rptID = sessionStorage.getItem("reportID")
        const url = `${process.env.VUE_APP_URL}/download-pdf/${rptID}`
        const response = await window.axios.get(url, { headers: { "Content-Type": "application/json" } })
        this.PDFuri = url // response.data.signedUrl
      } catch (error) {
        Swal.fire({
          title: "Error",
          text: `There was an error getting your report: ${error}`
        }).then(() => {
          this.$router.go(-1)
          console.error("Error getting PDF:", error)
        })
      }
    }
  }
}
</script>
